/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React from "react";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
// eslint-disable-next-line import/no-cycle
import PresetMockupColorPicker from "./PresetMockupColorPicker.vue";
import { MAX_PRINT_SIZES_GROUPED } from "../common/constants";
import ShirtMockup from "./ShirtMockup.vue";
import { getTitleCaseString } from "../utils";
import { useDtfStore } from "../store";
import "./MockupDisplay.scss";
import { renderList } from "common/vue/render-list";

function MockupDisplay({
  isMobile = false,
  artworkUrl = undefined,
  size = "small",
  index = 0,
  onClose,
  ...restProps
}: any) {
  const store = useDtfStore();

  function selectedColor() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.presetMockupColor[index];
  }

  const presets = Object.keys(MAX_PRINT_SIZES_GROUPED).filter(key => key !== "custom");

  function close() {
    onClose?.();
  }

  function presetTitle(preset: any) {
    return getTitleCaseString(preset);
  }

  return (
    <div {...restProps} className={cn("mockup-display", restProps.className)}>
      <div className="mockup-display__header">
        <div className="mockup-display__header-title">Jiffy Size Guide</div>
        <div
          className="mockup-display__close-button"
          onClick={close}
          data-testid="mockup-display-close-button"
        >
          <UseSvg
            className="mockup-display__close-button-icon"
            icon="menu-close"
            data-testid="mockup-display-close-button-icon"
          />
        </div>
      </div>
      <div className="mockup-display__content">
        <div className="mockup-display__presets-grid">
          {renderList(presets, preset => (
            <div className="mockup-display__presets-grid-item" key={preset}>
              <ShirtMockup
                artworkUrl={artworkUrl}
                preset={preset}
                selectedColor={selectedColor()}
                size={size}
                data-testid="shirt-mockup"
              />
              <p>{presetTitle(preset)}</p>
            </div>
          ))}
        </div>
        <PresetMockupColorPicker
          isMockupModal={true}
          index={index}
          data-testid="preset-mockup-color-picker"
        />
      </div>
    </div>
  );
}

export default MockupDisplay;
